(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ss-sizing-chart"]) return;
  try {
    
const isDesignMode = typeof Shopify != 'undefined' && Shopify.designMode;
var sizeChartData = null;
function checkImage(url, cb) {
	let img = new Image();
	img.onload = function() { cb(true); };
	img.onerror = function() { cb(false); };
	img.src = url;
}
function getCell(row, col) {
	let table = document.querySelector('.table-size');
    var tableRow = table.rows[row];
    if (tableRow) {
        var cell = tableRow.cells[col];
        return cell;
    }
    return null;
}
function markCell(row, col) {
	let table = document.querySelector('.table-size');
	if(table) {
		let cells = table.querySelectorAll('td.selected, th.selected');
		cells.forEach(cell => cell.classList.remove('selected','active'));

		let cell = table.rows[row].cells[col];
		cell.classList.add('selected');
		cell.classList.add('active');

		for (let i = 0; i <= row; i++) {
		  table.rows[i].cells[col].classList.add('selected');
		}
		for (let i = 0; i <= col; i++) {
		  table.rows[row].cells[i].classList.add('selected');
		}

		var tbl = cell.closest('table'),
        type = tbl.getAttribute('data-type'),
        size = cell.getAttribute('data-size'),
        cloth = cell.getAttribute('data-cloth'),
        slug = cell.getAttribute('data-slug'),
        typeSize = tbl.getAttribute('data-typeSize'),
        typeCloth = tbl.getAttribute('data-typeCloth'),
        img = '', imgSize = '', imgCloth = '', sizeArr = size.split('x'), clothArr = cloth.split('x');
        switch(typeSize) {
          case 'round':
            imgSize = size;
          break;
          case 'square':
            imgSize = size+'x'+size;
          break;
          case 'rectangle':
            imgSize = sizeArr[0]+'x'+sizeArr[1];
          break;
        }
        switch(typeCloth) {
          case 'round':
            imgCloth = cloth;
          break;
          case 'square':
            imgCloth = cloth+'x'+cloth;
          break;
          case 'rectangle':
            imgCloth = clothArr[0]+'x'+clothArr[1];
          break;
        }
        img = `${imgSize}-${slug}-${imgCloth}.jpg`;
        let tipContent = document.querySelector('.tool-tip .tool-tip__content');
        let domainUrl = 'https://'+tipContent.getAttribute('domain')+'/cdn/shop/files/';
        document.querySelector('[name="cloth"]').value = cloth;
        checkImage(domainUrl+img,function(exist){
			if(exist) {
                document.querySelector('.img-wrap').innerHTML = '<img src="'+domainUrl+img+'" alt="Table">';
			}else{
              let info = '';
              if(isDesignMode) {
                info = `<p>Please upload <strong>${img}</strong> file via <a class="link" href="https://${tipContent.getAttribute('domain')}/admin/settings/files" target="_blank">Files Upload</a></p>
                  <p>If you not able open the <strong>Files Upload</strong> link.</p>
                  <ol>
                  <li>Open a new tab or window in your browser.</li>
                    <li>Log in to your Shopify Admin.</li>
                    <li>Navigate to <strong>Content</strong> > <strong>Files</strong>.</li>
                    <li>Upload your files as needed.</li>
                   </ol>`;
                info = `<div class="img-info"><p>Sorry the image (${img}) is not found!</p>${info}</div>`;
              }
              document.querySelector('.img-wrap').innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 29" style="enable-background:new 0 0 40 29" xml:space="preserve"><linearGradient id="a" gradientUnits="userSpaceOnUse" x1="20" y1="94" x2="20" y2="115.224" gradientTransform="translate(0 -94)"><stop offset="0" style="stop-color:#002b68"/><stop offset="1" style="stop-color:#61dad3"/></linearGradient><path style="fill:url(#a)" d="M0 0h40v29H0z"/><circle cx="7.9" cy="9" r="2.5" style="fill:#fff"/><linearGradient id="b" gradientUnits="userSpaceOnUse" x1="20" y1="108.588" x2="20" y2="122.511" gradientTransform="translate(0 -94)"><stop offset="0" style="stop-color:#002b68"/><stop offset="1" style="stop-color:#61dad3"/></linearGradient><path d="M40 21.7V29H0v-5l13.9-8.8c.6-.5 1.7-.5 2.3 0l3.1 2.2c.6.5 1.7.5 2.3 0h.1l3.9-3.3c.6-.5 1.6-.6 2.3-.1h.1l12 7.7z" style="fill:url(#b)"/></svg>${info}`;
			}
		});
	}
}
function loadForm(tableType) {
	var htm = '', tblOpt = '', form = document.querySelector('.tool-tip .form-wrap'), labelSize = 'Table Size', labelCloth = 'Table Cloth', labelShape = 'Table Shape';
    if(form) {
     labelSize = form.getAttribute('label-size');
     labelCloth = form.getAttribute('label-cloth');
     labelShape = form.getAttribute('label-shape');
    }
	Object.keys(sizeChartData).forEach((type) => {
		let dataType = sizeChartData[type].type, typeSize = sizeChartData[type].typeSize, typeCloth = sizeChartData[type].typeCloth;
        tblOpt += `<option value="${sizeChartData[type].slug}"${type==tableType?' selected':''}>${sizeChartData[type].title}</option>`;
		if(type==tableType) {
			var size, cloth;
			if(sizeChartData[type].size) {
				size = sizeChartData[type].size;
			}
			if(sizeChartData[type].cloth) {
				cloth = sizeChartData[type].cloth;
			}
			if(size) {
				htm += '<div class="mb-3"><label>'+labelSize+'</label><select name="size">';
				var attrValue, attrLabel;
				for (let i = 0; i < size.length; i++) {
					switch(typeSize) {
						case'round':
							attrValue = size[i];
							attrLabel = size[i]+'"';
						break;
						case'square':
							attrValue = size[i];
							attrLabel = size[i]+'" x '+size[i]+'"';
						break;
						case'rectangle':
							attrValue = size[i][0]+'x'+size[i][1];
							attrLabel = size[i][0]+'" x '+size[i][1]+'"';
						break;
					}
					htm += '<option value="'+attrValue+'">'+attrLabel+'</option>';
				}
				htm += '</select></div>';
			}
			if(cloth) {
				htm += '<div class="mb-3"><label>'+labelCloth+'</label><select name="cloth">';
				var attrValue, attrLabel;
				for (let i = 0; i < cloth.length; i++) {
					switch(typeCloth) {
						case'round':
							attrValue = cloth[i];
							attrLabel = cloth[i]+'"';
						break;
						case'square':
							attrValue = cloth[i];
							attrLabel = cloth[i]+'" x '+cloth[i]+'"';
						break;
						case'rectangle':
							attrValue = cloth[i][0]+'x'+cloth[i][1];
							attrLabel = cloth[i][0]+'" x '+cloth[i][1]+'"';
						break;
					}
					htm += '<option value="'+attrValue+'">'+attrLabel+'</option>';
				}
				htm += '</select></div>';
			}
		}
	});
    document.querySelector('[name="table-shape"]').closest('div').querySelector('label').textContent = labelShape;
    document.querySelector('[name="table-shape"]').innerHTML = tblOpt;
    document.querySelector('.result-form').innerHTML = htm;
}
function loadTable(tableType) {
	var tbl = '', th = '', td = '', tblRes = document.querySelector('.result-table');
	var isShort = function(num) {
		return num < 0;
	}
	if(sizeChartData[tableType]) {
		var cloth = sizeChartData[tableType].cloth, size = sizeChartData[tableType].size, label = sizeChartData[tableType].title, type = sizeChartData[tableType].type, slug = sizeChartData[tableType].slug;
        label = type.charAt(0).toUpperCase() + type.slice(1);
		tbl += '<table class="table-size" data-type="'+type+'" data-typeSize="'+sizeChartData[tableType].typeSize+'" data-typeCloth="'+sizeChartData[tableType].typeCloth+'"><tbody>';
		for (let i = 0; i < cloth.length; i++) {
			td += '<tr>';
				if(type == 'rectangle') {
					td += '<td data-cloth="'+cloth[i][0]+'x'+cloth[i][1]+'">'+cloth[i][0]+'" x '+cloth[i][1]+'" '+label+'</td>';
				}else{
					td += '<td data-cloth="'+cloth[i]+'">'+cloth[i]+'" '+label+'</td>';
				}
				for (let j = 0; j < size.length; j++) {
					if(i==0) {
						if(type == 'rectangle') {
							th += '<td data-size="'+size[j][0]+'x'+size[j][1]+'">'+size[j][0]+'" x '+size[j][1]+'" '+label+'</td>';
						}else{
							th += '<td data-size="'+size[j]+'">'+size[j]+'" '+label+'</td>';
						}
					}
					var tdValue = 'Too Short', isValShort = true;
					if(type == 'rectangle') {
						if(!isShort((cloth[i][0]-size[j][0])/2) || !isShort((cloth[i][1]-size[j][1])/2)) {
							isValShort = false;
							tdValue = (cloth[i][0]-size[j][0])/2+'" Short / '+(cloth[i][1]-size[j][1])/2+'" Long';
						}
					}else{
						if(!isShort((cloth[i]-size[j])/2)) {
							isValShort = false;
							tdValue = (cloth[i]-size[j])/2+'" drop';
						}
					}
					if(type == 'rectangle') {
						td += '<td data-slug="'+slug+'" data-cloth="'+cloth[i][0]+'x'+cloth[i][1]+'" data-size="'+size[j][0]+'x'+size[j][1]+'" data-short="'+isValShort+'">'+tdValue+'</td>';
					}else{
						td += '<td data-slug="'+slug+'" data-cloth="'+cloth[i]+'" data-size="'+size[j]+'" data-short="'+isValShort+'">'+tdValue+'</td>';
					}
				}
			td += '</tr>';
		}
		tbl += '<tr><td></td>'+th+'</tr>';
		tbl += td;
		tbl += '</tbody></table>';

        if(typeof sizeChartData[tableType].label != 'undefined') {
          document.querySelector('.tbl-head-hor').innerHTML = sizeChartData[tableType].label.hr;
          document.querySelector('.tbl-head-ver').innerHTML = sizeChartData[tableType].label.vr;
        }
	}
	tblRes.innerHTML = tbl;
    if (document.querySelector('[name="table-shape"]').value.includes('overlay')) {
      tblRes.closest('table').style.display = 'none';
    } else {
      tblRes.closest('table').style.display = '';
    }

	document.querySelectorAll('[name="size"],[name="cloth"],[name="table-shape"]').forEach((field)=> {
		field.addEventListener('change', function() {
			var tblRow, tblCol;
			if(document.querySelector('[name="size"]') && document.querySelector('[name="cloth"]') && document.querySelector('[name="table-shape"]')) {
				var size = document.querySelector('[name="size"]').value;
				var cloth = document.querySelector('[name="cloth"]').value;
				var type = document.querySelector('[name="table-shape"]').value;
				var table = document.querySelector('.result-table .table-size');
				tblRow = table.querySelector('[data-cloth="'+cloth+'"]').closest('tr').rowIndex;
				tblCol = table.querySelector('[data-size="'+size+'"]').cellIndex;

				if(getCell(tblRow,tblCol).getAttribute('data-short')=='true' && !type.includes('overlay')) {
					tblRow = tblRow+1;
					if(getCell(tblRow,tblCol).getAttribute('data-short')=='true') {
						tblRow = tblRow+1;
						if(getCell(tblRow,tblCol).getAttribute('data-short')=='true') {
							tblRow = tblRow+1;
							if(getCell(tblRow,tblCol).getAttribute('data-short')=='true') {
								tblRow = tblRow+1;
							}
						}
					}
				}
				markCell(tblRow, tblCol);
			}
		});
	});
	setTimeout(function() {
      if(document.querySelector('[name="size"]')) {
		document.querySelector('[name="size"]').dispatchEvent(new Event('change'));
      }else{
        document.querySelector('.img-wrap').textContent = '';
        document.querySelector('.result-table').textContent = 'No data available!';
      }
	},0);
}
function getSizeChartData(){
  let objData = {};
  let scElm = document.querySelector('.tool-tip .tool-tip__content');
  if(scElm) {
    let scJson = scElm.getAttribute('data'), scData = JSON.parse(scJson);
    scData.map((data, index) => {
      let size = data.size.split(', '), cloth = data.cloth.split(', '), type = '';
      if(size[0]) {
          if(size[0].includes('x')) {
              let s = size[0].split('x');
              if(s[0] == s[1]) {
                  type = 'square';
                  data.size = size.map((data) => { return parseInt(data.split('x')[0]) });
              }else{
                  type = 'rectangle';
                  data.size = size.map((data) => { return [parseInt(data.split('x')[0]),parseInt(data.split('x')[1])] });
              }
          }else{
              type = 'round';
              data.size = size.map((data) => { return parseInt(data.split(',')[0]) });
          }
          data.typeSize = type;
      }
      if(cloth[0]) {
          if(cloth[0].includes('x')) {
              let s = cloth[0].split('x');
              if(s[0] == s[1]) {
                  type = 'square';
                  data.cloth = cloth.map((data) => { return parseInt(data.split('x')[0]) });
              }else{
                  type = 'rectangle';
                  data.cloth = cloth.map((data) => { return [parseInt(data.split('x')[0]),parseInt(data.split('x')[1])] });
              }
          }else{
              type = 'round';
              data.cloth = cloth.map((data) => { return parseInt(data.split(',')[0]) });
          }
          data.typeCloth = type;
      }
      data.type = type;
    });
    scData.forEach((data, index) => {
      if(data.type) {
          objData[data.slug] = data;
      }
    });
  }
  return objData;
}
try {
  let scOpen = document.querySelector('[data-open="size-chart"]');
  let scClose = document.querySelector('.tool-tip .tool-tip__close');
  if(scOpen) {
    scOpen.addEventListener('click',(e) => {
      e.preventDefault();
      if(document.querySelector('.tool-tip')) {
        document.querySelector('.tool-tip').setAttribute('open',true);
      }
    });
  }
  if(scClose) {
    scClose.addEventListener('click',(e) => {
      e.preventDefault();
      if(e.target.closest('.tool-tip')) {
        e.target.closest('.tool-tip').setAttribute('open',false);
      }
    });
  }
  let scElm = document.querySelector('.tool-tip .tool-tip__content');
  if(scElm) {
    let scJson = scElm.getAttribute('data'), scData = JSON.parse(scJson);
    if(scData) {
      scData.map((data, index) => {
		let size = data.size.split(', '), cloth = data.cloth.split(', '), type = '';
		if(size[0]) {
			if(size[0].includes('x')) {
				let s = size[0].split('x');
				if(s[0] == s[1]) {
					type = 'square';
					data.size = size.map((data) => { return parseInt(data.split('x')[0]) });
				}else{
					type = 'rectangle';
					data.size = size.map((data) => { return [parseInt(data.split('x')[0]),parseInt(data.split('x')[1])] });
				}
			}else{
				type = 'round';
				data.size = size.map((data) => { return parseInt(data.split(',')[0]) });
			}
            data.typeSize = type;
		}
		if(cloth[0]) {
			if(cloth[0].includes('x')) {
				let s = cloth[0].split('x');
				if(s[0] == s[1]) {
					type = 'square';
					data.cloth = cloth.map((data) => { return parseInt(data.split('x')[0]) });
				}else{
					type = 'rectangle';
					data.cloth = cloth.map((data) => { return [parseInt(data.split('x')[0]),parseInt(data.split('x')[1])] });
				}
			}else{
				type = 'round';
				data.cloth = cloth.map((data) => { return parseInt(data.split(',')[0]) });
			}
            data.typeCloth = type;
		}
        data.type = type;
     });
     let objData = {};
     scData.forEach((data, index) => {
		if(data.type) {
			objData[data.slug] = data;
		}
     });
     sizeChartData = objData;
     document.addEventListener('DOMContentLoaded',function(){
    	document.querySelector('[name="table-shape"]').addEventListener('change', function() {
            loadForm(this.value);
    		loadTable(this.value);
            if(scElm) {
              scElm.setAttribute('loading',false);
            }
    	});
    	document.querySelector('[name="table-shape"]').dispatchEvent(new Event('change'));
    });
    }
  }
}catch(err) {
  console.error(err);
}
if(isDesignMode) {
  document.addEventListener('shopify:section:select', (e) => {
    if(e.target.classList.contains('sizing-chart') && document.querySelector('.tool-tip')) {
      document.querySelector('.tool-tip').setAttribute('open',true);
    }
  });
  document.addEventListener('shopify:block:select', (e) => {
    if(e.target.classList.contains('block-sizing-chart') && document.querySelector('.tool-tip')) {
      document.querySelector('.tool-tip').setAttribute('open',true);
    }
  });
  document.addEventListener('shopify:section:deselect', (e) => {
    if(e.target.classList.contains('sizing-chart') && document.querySelector('.tool-tip')) {
      document.querySelector('.tool-tip').setAttribute('open',false);
    }
  });
  document.addEventListener('shopify:section:load', (e) => {
    if(e.target.classList.contains('sizing-chart') && document.querySelector('.tool-tip .tool-tip__content')) {
      sizeChartData = getSizeChartData();
      document.querySelector('[name="table-shape"]').addEventListener('change', function() {
            loadForm(this.value);
    		loadTable(this.value);
            if(scElm) {
              scElm.setAttribute('loading',false);
            }
    	});
      document.querySelector('[name="table-shape"]').dispatchEvent(new Event('change'));
      document.querySelector('.tool-tip .tool-tip__content').setAttribute('loading',false);
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
